export const LOGO_URL = "https://customer-assets.emergentagent.com/job_76dcac64-6245-4fa0-9206-f5b5b98f8f0b/artifacts/wocz35f4_Blue%20and%20Black%20Minimalist%20Brand%20Logo%20%287%29%202%20%282%29.png";

export const WHATSAPP_NUMBER = "916304199686"; // no '+' or spaces
export const WHATSAPP_DISPLAY = "+91 63041 99686";
export const WHATSAPP_MSG = encodeURIComponent("Hi IDOES, I'd like to talk about a project.");
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MSG}`;

export const EMAIL = "idoescreative@gmail.com";

export const SOCIALS = {
  instagram: "https://www.instagram.com/idoes.in?igsh=bzV5cHJzcTlycnFl&utm_source=qr",
  linkedin: "https://www.linkedin.com/in/yashwanth-sai-b6047b227/",
  whatsapp: WHATSAPP_URL,
};

export const SERVICES = [
  "WEBSITE DESIGN & DEVELOPMENT",
  "MOBILE APP DESIGN & DEVELOPMENT",
  "UI/UX DESIGN",
  "LOGO DESIGN & ANIMATION",
  "REEL SHOOTING & VIDEO EDITING",
  "BRANDING & CREATIVE DESIGN",
];

export const SERVICE_DESCRIPTIONS = {
  "WEBSITE DESIGN & DEVELOPMENT": "Conversion-focused websites built on clean code. From landing pages to complex platforms.",
  "MOBILE APP DESIGN & DEVELOPMENT": "iOS and Android apps designed for retention. Built with React Native or native stacks.",
  "UI/UX DESIGN": "Interfaces that feel obvious. Research-led, prototype-driven, user-tested.",
  "LOGO DESIGN & ANIMATION": "Marks that hold up at 16px and 16 feet. With motion that makes them memorable.",
  "REEL SHOOTING & VIDEO EDITING": "Short-form content shot and cut to stop scrolls. Brand films that actually get watched.",
  "BRANDING & CREATIVE DESIGN": "Complete identity systems. From strategy and tone to print and packaging.",
};

export const TICKER_ITEMS = [
  "WEBSITE DESIGN",
  "APP DEVELOPMENT",
  "UI/UX DESIGN",
  "LOGO DESIGN",
  "LOGO ANIMATION",
  "REEL SHOOTING",
  "VIDEO EDITING",
  "BRANDING",
];
